(function () {
  const CART_I18N = {
    zh: {
      title: "购物车",
      selectedProducts: "已选商品",
      orderSummary: "订单汇总",
      subtotal: "商品小计",
      fulfilment: "取货方式",
      fulfilmentHeading: "取货或配送方式",
      pickup: "自提",
      delivery: "配送",
      pickupDescription: "在指定日期、地点和时间领取订单",
      deliveryDescription: "订单满 €59 可选择",
      pickupFree: "自提：免费",
      deliveryFree: "配送：免费",
      deliveryUnavailable: "配送暂未开启，请选择自提。",
      orderTotal: "订单总计",
      unitPrice: "单价",
      itemTotal: "商品小计",
      remove: "删除",
      quantity: "数量",
      decreaseQuantity: "减少数量",
      increaseQuantity: "增加数量",
      updateCart: "更新购物车",
      checkout: "去结账",
      continueShopping: "继续选购",
      emptyCart: "购物车还是空的",
      emptyLine2: "去看看今天烤了什么吧。",
      taxNote: "税费及最终金额将在结账时确认。",
      paymentNote: "可用付款方式将在下一步显示。",
      pickupDate: "自提日期",
      deliveryDate: "配送日期",
      selectDate: "请选择日期",
      pickupLocation: "自提地点",
      pickupTime: "自提时间",
      deliveryInfoTitle: "鹿特丹地区免费配送",
      deliveryInfoDays: "周一至周五配送",
      deliveryInfoTime: "通常于 __TIME__ 送达",
      estimatedDeliveryTime: "预计配送时间：__TIME__",
      deliveryAddressNote: "配送地址和联系电话将在下一步付款页面填写。免费配送目前仅适用于鹿特丹地区。",
      noteLabel: "订单备注（选填）",
      notePlaceholder: "如有特殊需求，请在这里说明。",
      noscript: "购物车需要 JavaScript 来验证取货或配送信息后再进入付款。请开启 JavaScript，或联系小满下单。",
      loading: "正在更新…",
      updated: "购物车已更新",
      error: "更新失败，请重试",
      thresholdLocked: "还差 **AMOUNT** 可选择鹿特丹配送。",
      thresholdUnlocked: "已满足配送条件，可选择自提或配送。",
      selectPickupDate: "请选择自提日期。",
      selectPickupLocation: "请选择自提地点。",
      selectPickupTime: "请选择自提时间。",
      selectDeliveryDate: "请选择配送日期。",
      deliveryMinimum: "当前订单未达到免费配送金额。",
      completeInfo: "请先完成取货或配送信息。",
      cartEmpty: "购物车还是空的",
      weekdayNames: ["周日", "周一", "周二", "周三", "周四", "周五", "周六"],
      monthNames: ["1月", "2月", "3月", "4月", "5月", "6月", "7月", "8月", "9月", "10月", "11月", "12月"]
    },
    en: {
      title: "YOUR CART",
      selectedProducts: "Selected products",
      orderSummary: "Order summary",
      subtotal: "Subtotal",
      fulfilment: "Fulfilment",
      fulfilmentHeading: "Pickup or delivery",
      pickup: "Pickup",
      delivery: "Delivery",
      pickupDescription: "Collect your order at a selected date, location and time.",
      deliveryDescription: "Available for orders of €59 or more.",
      pickupFree: "Pickup: free",
      deliveryFree: "Delivery: free",
      deliveryUnavailable: "Delivery is currently disabled. Please choose pickup.",
      orderTotal: "Order total",
      unitPrice: "Unit price",
      itemTotal: "Item total",
      remove: "Remove",
      quantity: "Quantity",
      decreaseQuantity: "Decrease quantity",
      increaseQuantity: "Increase quantity",
      updateCart: "Update cart",
      checkout: "Checkout",
      continueShopping: "Continue shopping",
      emptyCart: "Your cart is empty",
      emptyLine2: "Take a look at what Xiaoman is baking today.",
      taxNote: "Taxes and the final total will be confirmed at checkout.",
      paymentNote: "Available payment methods will be shown at checkout.",
      pickupDate: "Pickup date",
      deliveryDate: "Delivery date",
      selectDate: "Select a date",
      pickupLocation: "Pickup location",
      pickupTime: "Pickup time",
      deliveryInfoTitle: "Free delivery in Rotterdam",
      deliveryInfoDays: "Available Monday to Friday",
      deliveryInfoTime: "Deliveries are usually made between __TIME__.",
      estimatedDeliveryTime: "Estimated delivery time: __TIME__",
      deliveryAddressNote: "Your delivery address and phone number will be collected at checkout. Free delivery is currently available within Rotterdam only.",
      noteLabel: "Order note (optional)",
      notePlaceholder: "Please let us know if you have any special requests.",
      noscript: "JavaScript is required to validate pickup or delivery information before checkout. Please enable JavaScript or contact Xiaoman to place your order.",
      loading: "Updating…",
      updated: "Cart updated",
      error: "Something went wrong. Please try again.",
      thresholdLocked: "**AMOUNT** more to choose Rotterdam delivery.",
      thresholdUnlocked: "Delivery conditions met. You can choose pickup or delivery.",
      selectPickupDate: "Please select a pickup date.",
      selectPickupLocation: "Please select a pickup location.",
      selectPickupTime: "Please select a pickup time.",
      selectDeliveryDate: "Please select a delivery date.",
      deliveryMinimum: "Your order does not meet the free delivery minimum.",
      completeInfo: "Please complete your pickup or delivery information.",
      cartEmpty: "Your cart is empty",
      weekdayNames: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
      monthNames: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"]
    }
  };

  const root = document.querySelector("[data-breaday-cart]");
  if (!root) return;

  const configEl = root.querySelector("[data-cart-config]");
  if (!configEl) return;

  let config;
  try {
    config = JSON.parse(configEl.textContent);
  } catch (error) {
    console.error("BREADAY cart config could not be parsed.", error);
    return;
  }

  function getBreadayLanguage() {
    try {
      return window.localStorage.getItem("breaday_language") === "en" ? "en" : "zh";
    } catch (error) {
      return document.documentElement.getAttribute("data-breaday-language") === "en" ? "en" : "zh";
    }
  }

  const language = getBreadayLanguage();
  const translations = Object.assign({}, CART_I18N[language] || CART_I18N.zh, config.translations || {});
  const locale = language === "en" ? "en-US" : "zh-CN";
  const routeRoot = window.Shopify && window.Shopify.routes && window.Shopify.routes.root
    ? window.Shopify.routes.root
    : (config.routes.root || "/");

  function translateValue(key, element) {
    let value = translations[key] || "";
    if (element && element.dataset.cartI18nTime) {
      value = value.replace("__TIME__", element.dataset.cartI18nTime);
    }
    if (element && element.dataset.cartI18nSuffix) {
      value += element.dataset.cartI18nSuffix;
    }
    return value;
  }

  function applyCartTranslations() {
    root.querySelectorAll("[data-cart-i18n]").forEach((element) => {
      const key = element.dataset.cartI18n;
      const value = translateValue(key, element);
      if (value) element.textContent = value;
    });

    root.querySelectorAll("[data-cart-i18n-aria]").forEach((element) => {
      const value = translations[element.dataset.cartI18nAria];
      if (value) element.setAttribute("aria-label", value);
    });

    root.querySelectorAll("[data-cart-i18n-placeholder]").forEach((element) => {
      const value = translations[element.dataset.cartI18nPlaceholder];
      if (value) element.setAttribute("placeholder", value);
    });

    root.querySelectorAll("[data-cart-localized-option]").forEach((element) => {
      const value = language === "en" ? element.dataset.en : element.dataset.zh;
      if (value) element.textContent = value;
    });

    root.querySelectorAll("[data-pickup-location]").forEach((input) => {
      const value = language === "en" ? input.dataset.locationNameEn : input.dataset.locationNameZh;
      if (value) input.dataset.locationName = value;
    });
  }

  applyCartTranslations();

  const state = {
    cart: null,
    method: "pickup",
    isSaving: false,
    pendingNoteTimer: null
  };

  const selectors = {
    form: "[data-cart-form]",
    item: "[data-cart-item]",
    status: "[data-cart-status]",
    subtotal: "[data-cart-subtotal]",
    total: "[data-cart-total]",
    fulfilmentSummary: "[data-fulfilment-summary]",
    thresholdMessage: "[data-threshold-message]",
    checkoutButton: "[data-checkout-button]",
    note: "[data-cart-note]",
    deliveryCard: "[data-method-card='delivery']",
    panels: "[data-panel]",
    pickupDate: "[data-pickup-date]",
    deliveryDate: "[data-delivery-date]",
    pickupLocation: "[data-pickup-location]",
    pickupLocationName: "[data-pickup-location-name]",
    pickupTime: "[data-pickup-time]",
    pickupTimeField: "[data-field='pickup-time']",
    deliveryTime: "[data-delivery-time]"
  };

  const form = root.querySelector(selectors.form);
  if (!form) return;

  const attrNames = {
    method: "Fulfilment method",
    pickupDate: "Pickup date",
    pickupLocation: "Pickup location",
    pickupLocationName: "Pickup location name",
    pickupTime: "Pickup time slot",
    deliveryDate: "Delivery date",
    deliveryTime: "Delivery time"
  };

  const qs = (selector, base = root) => base.querySelector(selector);
  const qsa = (selector, base = root) => Array.from(base.querySelectorAll(selector));

  function endpoint(path) {
    return `${routeRoot.replace(/\/?$/, "/")}${String(path).replace(/^\//, "")}`;
  }

  function setStatus(message) {
    const status = qs(selectors.status);
    if (status) status.textContent = message || "";
  }

  function setBusy(isBusy) {
    state.isSaving = isBusy;
    root.classList.toggle("is-loading", isBusy);
    qsa("button", root).forEach((button) => {
      if (button.matches(selectors.checkoutButton)) return;
      button.disabled = isBusy;
    });
    const checkout = qs(selectors.checkoutButton);
    if (checkout) checkout.disabled = isBusy;
  }

  function money(cents) {
    const amount = Number(cents || 0) / 100;
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency: "EUR"
    }).format(amount);
  }

  async function requestCart(path, options = {}) {
    const response = await fetch(endpoint(path), {
      credentials: "same-origin",
      headers: {
        "Accept": "application/json",
        "Content-Type": "application/json"
      },
      ...options
    });
    if (!response.ok) {
      throw new Error(`Cart request failed: ${response.status}`);
    }
    return response.json();
  }

  async function getCart() {
    state.cart = await requestCart("cart.js");
    return state.cart;
  }

  function cartSubtotal() {
    return Number(state.cart && typeof state.cart.items_subtotal_price === "number"
      ? state.cart.items_subtotal_price
      : 0);
  }

  function deliveryAllowed() {
    return config.enableDelivery !== false && cartSubtotal() >= Number(config.thresholdCents || 5900);
  }

  function currentAttributes() {
    return (state.cart && state.cart.attributes) || config.attributes || {};
  }

  function getAttr(name) {
    const attrs = currentAttributes();
    return attrs && attrs[name] ? attrs[name] : "";
  }

  function amsterdamParts(date) {
    const parts = new Intl.DateTimeFormat("en-CA", {
      timeZone: "Europe/Amsterdam",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false
    }).formatToParts(date);
    const out = {};
    parts.forEach((part) => {
      if (part.type !== "literal") out[part.type] = part.value;
    });
    return {
      year: Number(out.year),
      month: Number(out.month),
      day: Number(out.day),
      hour: Number(out.hour),
      minute: Number(out.minute)
    };
  }

  function isoFromParts(parts) {
    return `${parts.year}-${String(parts.month).padStart(2, "0")}-${String(parts.day).padStart(2, "0")}`;
  }

  function dateFromAmsterdamOffset(offsetDays) {
    const now = amsterdamParts(new Date());
    const utcNoon = new Date(Date.UTC(now.year, now.month - 1, now.day + offsetDays, 12, 0, 0));
    return amsterdamParts(utcNoon);
  }

  function weekdayForIso(iso) {
    const [year, month, day] = iso.split("-").map(Number);
    return new Date(Date.UTC(year, month - 1, day, 12, 0, 0)).getUTCDay();
  }

  function getMinimumOffsetDays() {
    const now = amsterdamParts(new Date());
    const [cutoffHour, cutoffMinute] = String(config.cutoffTime || "15:00").split(":").map(Number);
    const afterCutoff = now.hour > cutoffHour || (now.hour === cutoffHour && now.minute >= (cutoffMinute || 0));
    return afterCutoff ? 2 : 1;
  }

  function buildDateOptions(enabledDays) {
    const options = [];
    const minOffset = getMinimumOffsetDays();
    const maxDays = Number(config.dateWindowDays || 14);
    for (let offset = minOffset; offset <= maxDays; offset += 1) {
      const parts = dateFromAmsterdamOffset(offset);
      const iso = isoFromParts(parts);
      const weekday = weekdayForIso(iso);
      if (enabledDays[weekday]) {
        options.push({ iso, label: formatDateLabel(parts, weekday) });
      }
    }
    return options;
  }

  function formatDateLabel(parts, weekday) {
    const weekdays = translations.weekdayNames || [];
    const months = translations.monthNames || [];
    if (language === "en") {
      return `${weekdays[weekday]}, ${parts.day} ${months[parts.month - 1]} ${parts.year}`;
    }
    return `${parts.year}年${parts.month}月${parts.day}日，${weekdays[weekday]}`;
  }

  function fillDateSelect(select, options, selectedValue) {
    if (!select) return;
    const first = select.querySelector("option[value='']");
    select.textContent = "";
    if (first) select.appendChild(first);
    options.forEach((option) => {
      const opt = document.createElement("option");
      opt.value = option.iso;
      opt.textContent = option.label;
      select.appendChild(opt);
    });
    select.value = options.some((option) => option.iso === selectedValue) ? selectedValue : "";
  }

  function isValidDateValue(value, options) {
    return options.some((option) => option.iso === value);
  }

  function syncDateOptions() {
    const pickupOptions = buildDateOptions(config.pickupDays || []);
    const deliveryOptions = buildDateOptions(config.deliveryDays || []);
    fillDateSelect(qs(selectors.pickupDate), pickupOptions, getAttr(attrNames.pickupDate));
    fillDateSelect(qs(selectors.deliveryDate), deliveryOptions, getAttr(attrNames.deliveryDate));
    return { pickupOptions, deliveryOptions };
  }

  function renderCartPrices() {
    const cart = state.cart;
    if (!cart) return;

    qsa(selectors.item).forEach((itemEl) => {
      const key = itemEl.dataset.key;
      const item = cart.items.find((entry) => entry.key === key);
      if (!item) {
        itemEl.remove();
        return;
      }
      const qty = qs("[data-quantity-input]", itemEl);
      const unit = qs("[data-item-unit-price]", itemEl);
      const line = qs("[data-item-line-price]", itemEl);
      if (qty) qty.value = item.quantity;
      if (unit) unit.textContent = money(item.final_price);
      if (line) line.textContent = money(item.final_line_price);
    });

    const subtotal = money(cart.items_subtotal_price);
    const subtotalEl = qs(selectors.subtotal);
    const totalEl = qs(selectors.total);
    if (subtotalEl) subtotalEl.textContent = subtotal;
    if (totalEl) totalEl.textContent = subtotal;

    if (cart.item_count === 0 || !qsa(selectors.item).length) {
      window.location.reload();
    }
  }

  function setMethod(method, options = {}) {
    const nextMethod = method === "delivery" && deliveryAllowed() ? "delivery" : "pickup";
    state.method = nextMethod;

    qsa("[data-method-input]").forEach((input) => {
      input.checked = input.value === nextMethod;
      const card = input.closest("[data-method-card]");
      if (card) card.setAttribute("aria-checked", input.checked ? "true" : "false");
    });

    const deliveryCard = qs(selectors.deliveryCard);
    if (deliveryCard) {
      const disabled = !deliveryAllowed();
      deliveryCard.classList.toggle("is-disabled", disabled);
      const input = qs("input", deliveryCard);
      if (input) input.disabled = disabled;
      deliveryCard.setAttribute("aria-disabled", disabled ? "true" : "false");
    }

    qsa(selectors.panels).forEach((panel) => {
      panel.hidden = panel.dataset.panel !== nextMethod;
    });

    const summary = qs(selectors.fulfilmentSummary);
    if (summary) {
      summary.textContent = nextMethod === "delivery" ? translations.deliveryFree : translations.pickupFree;
    }

    renderThreshold();

    if (options.persist) {
      saveAttributesFromUI({ quiet: true }).catch(showRequestError);
    }
  }

  function renderThreshold() {
    const message = qs(selectors.thresholdMessage);
    if (!message) return;
    if (config.enableDelivery === false) {
      message.textContent = translations.deliveryUnavailable || "";
    } else if (deliveryAllowed()) {
      message.textContent = translations.thresholdUnlocked || "";
    } else {
      const remaining = Math.max(Number(config.thresholdCents || 5900) - cartSubtotal(), 0);
      message.textContent = String(translations.thresholdLocked || "").replace("**AMOUNT**", money(remaining));
    }
  }

  function filterPickupTimeSlots() {
    const selectedLocation = qs(`${selectors.pickupLocation}:checked`);
    const timeField = qs(selectors.pickupTimeField);

    if (!timeField) return;

    if (!selectedLocation) {
      timeField.hidden = true;
      qsa(selectors.pickupTime).forEach((input) => {
        input.checked = false;
        input.disabled = true;
      });
      return;
    }

    const selectedLocationId = selectedLocation.value;
    let visibleCount = 0;

    qsa(selectors.pickupTime).forEach((input) => {
      const card = input.closest("[data-slot-location-ids]");
      if (!card) return;

      const allowedIds = String(card.dataset.slotLocationIds || "")
        .split(",")
        .map((id) => id.trim())
        .filter(Boolean);
      const matches = allowedIds.length === 0 || allowedIds.includes(selectedLocationId);

      card.hidden = !matches;
      input.disabled = !matches;

      if (!matches && input.checked) {
        input.checked = false;
      }

      if (matches) {
        visibleCount += 1;
      }
    });

    timeField.hidden = visibleCount === 0;
  }

  function restoreSelections() {
    const attrs = currentAttributes();
    const dateOptions = syncDateOptions();
    const method = attrs[attrNames.method] || "pickup";

    if (attrs[attrNames.pickupLocation]) {
      const location = radioByValue(selectors.pickupLocation, attrs[attrNames.pickupLocation]);
      if (location) location.checked = true;
    }
    filterPickupTimeSlots();

    if (attrs[attrNames.pickupTime]) {
      const time = qsa(selectors.pickupTime).find((input) => {
        const card = input.closest("[data-slot-location-ids]");
        return input.value === attrs[attrNames.pickupTime] && !input.disabled && card && !card.hidden;
      });
      if (time) time.checked = true;
    }

    const pickupDate = qs(selectors.pickupDate);
    const deliveryDate = qs(selectors.deliveryDate);
    if (pickupDate && !isValidDateValue(pickupDate.value, dateOptions.pickupOptions)) pickupDate.value = "";
    if (deliveryDate && !isValidDateValue(deliveryDate.value, dateOptions.deliveryOptions)) deliveryDate.value = "";

    const note = qs(selectors.note);
    if (note) note.value = state.cart && state.cart.note ? state.cart.note : (config.note || "");

    setMethod(method, { persist: method === "delivery" && !deliveryAllowed() });
    syncPickupLocationName();
  }

  function syncPickupLocationName() {
    const selected = qs(`${selectors.pickupLocation}:checked`);
    const hidden = qs(selectors.pickupLocationName);
    if (hidden) hidden.value = selected ? selected.dataset.locationName || "" : "";
  }

  function radioByValue(selector, value) {
    return qsa(selector).find((input) => input.value === value) || null;
  }

  function selectedValue(selector) {
    const el = qs(selector);
    return el ? el.value : "";
  }

  function checkedValue(selector) {
    const el = qs(`${selector}:checked`);
    return el ? el.value : "";
  }

  function buildAttributesFromUI() {
    const method = state.method === "delivery" && deliveryAllowed() ? "delivery" : "pickup";
    const attrs = {
      [attrNames.method]: method
    };

    if (method === "pickup") {
      attrs[attrNames.pickupDate] = selectedValue(selectors.pickupDate);
      attrs[attrNames.pickupLocation] = checkedValue(selectors.pickupLocation);
      attrs[attrNames.pickupLocationName] = selectedValue(selectors.pickupLocationName);
      attrs[attrNames.pickupTime] = checkedValue(selectors.pickupTime);
      attrs[attrNames.deliveryDate] = "";
      attrs[attrNames.deliveryTime] = "";
    } else {
      attrs[attrNames.pickupDate] = "";
      attrs[attrNames.pickupLocation] = "";
      attrs[attrNames.pickupLocationName] = "";
      attrs[attrNames.pickupTime] = "";
      attrs[attrNames.deliveryDate] = selectedValue(selectors.deliveryDate);
      attrs[attrNames.deliveryTime] = selectedValue(selectors.deliveryTime) || config.deliveryTime || "18:00–20:00";
    }

    return attrs;
  }

  async function saveAttributesFromUI(options = {}) {
    syncPickupLocationName();
    filterPickupTimeSlots();
    const body = { attributes: buildAttributesFromUI() };
    const note = qs(selectors.note);
    if (note) body.note = note.value;
    if (!options.quiet) setStatus(translations.loading);
    state.cart = await requestCart("cart/update.js", {
      method: "POST",
      body: JSON.stringify(body)
    });
    if (!options.quiet) setStatus(translations.updated);
    return state.cart;
  }

  async function changeLineItem(key, quantity, itemEl) {
    setBusy(true);
    setStatus(translations.loading);
    if (itemEl) itemEl.classList.add("is-loading");
    try {
      state.cart = await requestCart("cart/change.js", {
        method: "POST",
        body: JSON.stringify({ id: key, quantity })
      });
      renderCartPrices();
      if (!deliveryAllowed() && state.method === "delivery") {
        setMethod("pickup", { persist: true });
      } else {
        setMethod(state.method);
      }
      await saveAttributesFromUI({ quiet: true });
      setStatus(translations.updated);
    } catch (error) {
      console.error(error);
      showRequestError();
    } finally {
      if (itemEl) itemEl.classList.remove("is-loading");
      setBusy(false);
    }
  }

  function showRequestError() {
    setStatus(translations.error);
  }

  function clearErrors() {
    qsa("[data-error-for]").forEach((errorEl) => {
      errorEl.textContent = "";
    });
    qsa(".has-error", root).forEach((field) => {
      field.classList.remove("has-error");
    });
  }

  function showFieldError(fieldName, message) {
    const error = qs(`[data-error-for="${fieldName}"]`);
    const field = qs(`[data-field="${fieldName}"]`);
    if (error) error.textContent = message;
    if (field) field.classList.add("has-error");
    return field || error;
  }

  function validate() {
    clearErrors();
    const errors = [];

    if (state.method === "delivery") {
      if (!deliveryAllowed()) {
        errors.push(showFieldError("summary", translations.deliveryMinimum));
      }
      if (!selectedValue(selectors.deliveryDate)) {
        errors.push(showFieldError("delivery-date", translations.selectDeliveryDate));
      }
    } else {
      if (!selectedValue(selectors.pickupDate)) {
        errors.push(showFieldError("pickup-date", translations.selectPickupDate));
      }
      if (!checkedValue(selectors.pickupLocation)) {
        errors.push(showFieldError("pickup-location", translations.selectPickupLocation));
      }
      const selectedPickupTime = qs(`${selectors.pickupTime}:checked`);
      const selectedPickupTimeCard = selectedPickupTime ? selectedPickupTime.closest("[data-slot-location-ids]") : null;
      if (!selectedPickupTime || selectedPickupTime.disabled || !selectedPickupTimeCard || selectedPickupTimeCard.hidden) {
        errors.push(showFieldError("pickup-time", translations.selectPickupTime));
      }
    }

    if (errors.length) {
      const target = errors.find(Boolean);
      const summary = qs('[data-error-for="summary"]');
      if (summary && !summary.textContent) summary.textContent = translations.completeInfo;
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "center" });
        const focusable = target.querySelector("select, input, textarea, button");
        if (focusable) focusable.focus({ preventScroll: true });
      }
      return false;
    }
    return true;
  }

  function bindEvents() {
    qsa(selectors.item).forEach((itemEl) => {
      const key = itemEl.dataset.key;
      const input = qs("[data-quantity-input]", itemEl);
      qs("[data-quantity-minus]", itemEl)?.addEventListener("click", () => {
        const next = Math.max(Number(input.value || 0) - 1, 0);
        input.value = next;
        changeLineItem(key, next, itemEl);
      });
      qs("[data-quantity-plus]", itemEl)?.addEventListener("click", () => {
        const next = Number(input.value || 0) + 1;
        input.value = next;
        changeLineItem(key, next, itemEl);
      });
      qs("[data-remove-item]", itemEl)?.addEventListener("click", () => {
        input.value = 0;
        changeLineItem(key, 0, itemEl);
      });
      input?.addEventListener("change", () => {
        const next = Math.max(Number(input.value || 0), 0);
        input.value = next;
        changeLineItem(key, next, itemEl);
      });
    });

    qsa("[data-method-input]").forEach((input) => {
      input.addEventListener("change", () => {
        setMethod(input.value, { persist: true });
      });
    });

    qsa(`${selectors.pickupDate}, ${selectors.deliveryDate}, ${selectors.pickupLocation}, ${selectors.pickupTime}`).forEach((input) => {
      input.addEventListener("change", () => {
        clearErrors();
        if (input.matches(selectors.pickupLocation)) {
          syncPickupLocationName();
          filterPickupTimeSlots();
        }
        saveAttributesFromUI({ quiet: true }).catch(showRequestError);
      });
    });

    const note = qs(selectors.note);
    if (note) {
      note.addEventListener("input", () => {
        window.clearTimeout(state.pendingNoteTimer);
        state.pendingNoteTimer = window.setTimeout(() => {
          saveAttributesFromUI({ quiet: true }).catch(showRequestError);
        }, 700);
      });
      note.addEventListener("blur", () => {
        window.clearTimeout(state.pendingNoteTimer);
        saveAttributesFromUI({ quiet: true }).catch(showRequestError);
      });
    }

    form.addEventListener("submit", async (event) => {
      const submitter = event.submitter;
      if (submitter && submitter.name === "update") {
        return;
      }

      event.preventDefault();
      if (state.isSaving) return;
      if (!validate()) return;

      setBusy(true);
      try {
        await saveAttributesFromUI();
        if (!validate()) return;
        window.location.href = config.routes.checkout || endpoint("checkout");
      } catch (error) {
        console.error(error);
        showRequestError();
      } finally {
        setBusy(false);
      }
    });
  }

  async function init() {
    try {
      state.cart = await getCart();
    } catch (error) {
      console.error(error);
      state.cart = { items: [], item_count: 0, items_subtotal_price: 0, attributes: config.attributes || {}, note: config.note || "" };
      showRequestError();
    }
    renderCartPrices();
    restoreSelections();
    bindEvents();
    if (!getAttr(attrNames.method)) {
      saveAttributesFromUI({ quiet: true }).catch(showRequestError);
    }
  }

  init();
})();
